export default [
  {
    path: '/native-talk-report',
    component: () => import('./views/Index'),
    name: 'native-talk-report',
    redirect: { name: 'native-talk-report-list' },
    children: [
      {
        path: '',
        name: 'native-talk-report-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'social-plus',
        },
      },
      {
        path: ':id',
        name: 'native-talk-report-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'social-plus',
        },
      },
    ],
  },
]
